export default "/fonts/vendor/primeicons/primeicons.eot?d44157bdfa026dc877afddb9891a6c4a";